// One aggregate opening count. No time measurement, cookies, visitor IDs,
// account tokens, URLs, referrers, form values or fingerprinting attributes.
const OPT_OUT_KEY = 'mrf-analytics-opt-out';
const ENDPOINT = /^https:\/\/[a-z0-9]+\.execute-api\.eu-west-1\.amazonaws\.com\/collect$/;
function optedOut(win) {
  if (win.navigator.doNotTrack === '1' || win.navigator.globalPrivacyControl === true) return true;
  try { return win.localStorage.getItem(OPT_OUT_KEY) === '1'; } catch (_) { return true; }
}
let counted = false;
async function initializeMeasurement(win) {
  if (!win || counted || win.location.hostname !== 'www.movimentorivoluzionefiscale.it' || win.navigator.webdriver === true || optedOut(win)) return;
  try {
    const response = await win.fetch('/analytics-config.json', { credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer' });
    if (!response.ok) return;
    const config = await response.json();
    if (config.enabled !== true || !ENDPOINT.test(config.endpoint) || counted || optedOut(win)) return;
    counted = true;
    win.fetch(config.endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', keepalive: true,
      referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ v: 1, event: 'open' }) }).catch(() => {});
  } catch (_) { /* Counting failures never block the site or membership form. */ }
}
function startMeasurement(win) { initializeMeasurement(win); }
module.exports = { OPT_OUT_KEY, ENDPOINT, optedOut, startMeasurement };
